import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueRouter from 'vue-router'
import getRoutes from '@/routes'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import Meta from 'vue-meta'
import VueSignaturePad from 'vue-signature-pad'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import { strapi } from '@/api'
import { groupBy } from '@/utils/common'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueMask)

Vue.use(VueSignaturePad)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
;(async () => {
  Vue.config.productionTip = false

  Vue.use(VueRouter)
  Vue.use(Meta)

  const router = new VueRouter({
    mode: 'history',
    routes: await getRoutes()
  })

  Vue.use(
    VueGtag,
    {
      appName: 'MSM App',
      pageTrackerScreenviewEnabled: true,
      config: { id: process.env.VUE_APP_GA_ID }
    },
    router
  )

  const strapiHeader = await strapi
    .getAllHeaders()
    .then(({ data }) => {
      const headers = data.data
      const headersByLocale = groupBy(headers, h => h.attributes.locale)
      const attributesByLocale = Object.entries(headersByLocale).reduce((acc, [locale, headers]) => ({...acc, [locale]: headers[0].attributes}), {})
      return attributesByLocale
    })

  const strapiPages = await strapi
    .getAllPages()
    .then(({ data }) => {
      const pages = data.data
      const pagesByLocales = groupBy(pages, p => p.attributes.locale)
      const pagesByRoute = Object
          .entries(pagesByLocales)
          .map(([locale, pages]) => ({ [locale]: pages.reduce((acc, p) => 
            ({...acc, [p.attributes.route]: { position: p.attributes.position, label: p.attributes.label, showNavbar: p.attributes.showNavbar,
              components: p.attributes.components.map(({ __component, ...rest }) => ({
                __component: strapi.toVueComponentName(__component),
                ...rest
              })
            ) 
          }}), {}) })
          )
          .reduce((acc, pages) => ({...acc, ...pages}))
      return pagesByRoute
    })

	const strapiFooter = await strapi
    .getAllFooters()
    .then(({ data }) => {
      const footers = data.data
      const footersByLocale = groupBy(footers, f => f.attributes.locale)
      const attributesByLocale = Object.entries(footersByLocale).reduce((acc, [locale, footers]) => ({...acc, [locale]: footers[0].attributes}), {})
      return attributesByLocale
    })


  // Vue App
  new Vue({
    render: (h) => h(App, { props: { pages: strapiPages, headers: strapiHeader, footers: strapiFooter } }),
    router
  }).$mount('#app')
})()
